import {IRoom, IUser} from '../Constants/Interfaces';


export function sortChatsArray(chats: IRoom[]): typeof chats {
    let result = [] as typeof chats;
    let restOfTheRooms = [] as typeof chats;
    let lastRooms = [] as typeof chats;

    const defaultRoom = chats.find(
        ({link}) => link && window.location.href.includes(link),
    );

    for (let chat of chats) {
        if (chat.id === 'metaverse') {
            result[0] = chat;
        }
        else if (defaultRoom && chat.id === defaultRoom.id) {
            result[1] = chat;
        }
        else if (chat.timestamp < 0) {
            lastRooms.push(chat);
        }
        else {
            restOfTheRooms.push(chat);
        }
    }

    return [
        ...result,
        ...restOfTheRooms.sort((a, b) => (a.title > b.title ? 1 : -1)),
        ...lastRooms,
    ];
}


export function sortUserList(
    array: IUser[],
    buddies: string[],
    selectedChatId: string,
    notifications: { [uid: string]: number },
): IUser[] {
    return array
        .sort((a, b) => (a.online && b.online ? 0 : a.online ? -1 : 1))
        .sort((a, b) => {
            let result = 0;
            const userANumber = notifications[a.uid];
            const userBNumber = notifications[b.uid];
            if (a.online) {
                result--;
            }
            if (b.online) {
                result++;
            }
            if (!userANumber) {
                result++;
            }
            if (!userBNumber) {
                result--;
            }
            if (userANumber > userBNumber) {
                result++;
            }
            else {
                result--;
            }

            if (buddies.includes(a.uid)) {
                result--;
            }
            if (buddies.includes(b.uid)) {
                result++;
            }
            if (a.name.startsWith('Guest')) {
                result++;
            }
            if (a.online) {
                result--;
            }
            if (b.online) {
                result++;
            }
            return result;
        });
}
